<template>

  <el-tabs :value="utilTab">

    <el-tab-pane v-if="canAccess('finance')" label="Summary" name="tab1">

      <el-row  v-if="canAccess('finance')"  :gutter="16">
         <el-col :span="6">
            <dash-text :value="formatMoney(this.owingUtility, 0)"
             valueSize="3em;"
              caption="Total Owing"
               value-color="indianred" />
         </el-col>

         <el-col :span="6">
           <dash-text :value="formatMoney(this.owingOutstanding, 0)"
           caption="Sharers Outstanding"
           valueSize="3em;"
           value-color="seagreen" />
         </el-col>

         <el-col v-if="canAccess('finance')" :span="6">
           <dash-text :value="formatMoney(this.owingPenalties, 0)"
            caption="Penalties Due"
            valueSize="3em;"
            value-color="slateblue" />
         </el-col>

         <el-col :span="6" style="padding-top: 2em;">
           <site-utility-bill :site-data="rowData" />
        </el-col>

      </el-row>

      <hr />

      <util-finance-sharers-table v-if="sharers" :sharers="sharers" />

    </el-tab-pane>

    <el-tab-pane label="Utility Bill" name="tab2" lazy>
      <h3>Utility Billing</h3><br />
      <el-row v-if="this.rowData.tenancy.utilAddress && this.rowData.tenancy.utilAccount">
        <el-col :span="3">
          <span class="text-muted">Billing Address</span>
        </el-col>
        <el-col :span="5">
          <strong>{{this.rowData.tenancy.utilAddress}}</strong>
        </el-col>

        <el-col :span="3" :offset="2">
          <span class="text-muted">Account No.</span>
        </el-col>
        <el-col :span="6">
          <strong>{{this.rowData.tenancy.utilAccount}}</strong>
        </el-col>

        <el-col :span="2">
          <site-utility-bill :site-data="rowData" />
        </el-col>

      </el-row>
      <el-row v-else>
        <h3>No Billing address found</h3>
      </el-row>

      <site-util-table :hide-heading="true" :row-data="rowData" />

    </el-tab-pane>

    <el-tab-pane v-if="canAccess('finance')" label="Payment" name="tab3" lazy>
       <utility-licensee-payment :rowData="rowData" />
    </el-tab-pane>
  </el-tabs>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

import DashText from '@/components/atoms/DashText'

import SiteUtilityBill from '@/components/actions/UtilityBillAction'
import SiteUtilTable from '@/components/sites/utility/SiteUtilTable'
import UtilityLicenseePayment from '@/components/utility/UtilityLicenseePayment'
import UtilFinanceSharersTable from '@/components/sites/utility/UtilFinanceSharersTable'


export default {

  mixins: [SiteMixins],

  components: {
    DashText,
    SiteUtilityBill,
    SiteUtilTable,
    UtilityLicenseePayment,
    UtilFinanceSharersTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    sharers: {
      type: [Object, Array],
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    }
  },


  methods: {

    setStatement (statement) {
      this.summary = statement
    }

  },


  computed: {

    rental () {
      return 0
    },

    owingUtility () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'U' && this.summary[i].ledger === 'DR') {
            res += this.summary[i].outstanding ? Number(this.summary[i].outstanding) : 0
          }
        }
      }

      return Math.abs(res)
    },

    owingPenalties () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          res += Math.abs(this.summary[i].penalties)
        }
      }

      return res
    },

    owingOutstanding () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'U' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].outstanding ? this.summary[i].outstanding : 0
          }
        }
      }

      return res
    }

  },

  data () {
    return {
      utilTab: this.canAccess('finance') ? 'tab1' : 'tab2',
      summary: []
    }
  }

}
</script>
